import React, { FC } from "react";
import "./ActionButton.scss";

export interface ActionButtonProps {
    onClick?: (label: string) => void;
    readonly type?: "button" | "submit";
    readonly label: string;
    readonly addClass?: string;
    readonly disable?: boolean;
}

const ActionButton: FC<ActionButtonProps> = ({
    label,
    disable,
    type,
    addClass,
    onClick,
}: ActionButtonProps) => {
    function handleClick(ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        ev.stopPropagation();
        if (onClick) {
            onClick(label);
        }
    }

    return (
        <button
            disabled={disable}
            type={type}
            className={`action-button ${addClass}`}
            onClick={handleClick}>
            {label}
        </button>
    );
};

export default ActionButton;
